// src/components/LikeButton.js

import React, { useContext, useMemo, useState } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { useToggleLikeRQ } from '../hooks/rq/useToggleLike';

// 📍 Contextos para calcular la ubicación efectiva y estado auth
import { AuthContext }     from '../context/AuthContext';
import { FilterContext }   from '../context/FilterContext';
import { LocationContext } from '../context/LocationContext';
// ➕ Importamos el ModalSignIn para abrirlo
import ModalSignIn from './ModalSignIn';
import { ModalContext } from '../context/ModalContext';

const LikeButton = ({ petId, initialIsFavorite }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const { openModal }       = useContext(ModalContext);
  const { user }            = useContext(AuthContext);
  const { filters }         = useContext(FilterContext);
  const { coords }          = useContext(LocationContext);

  // 1) Derivar ubicación efectiva (igual que antes)
  const location = useMemo(() => {
    if (user?.latitude != null && user?.longitude != null) {
      return { lat: user.latitude, lng: user.longitude };
    }
    if (filters.location?.lat != null && filters.location?.lng != null) {
      return { lat: filters.location.lat, lng: filters.location.lng };
    }
    return { lat: coords.lat, lng: coords.lng };
  }, [user, filters.location, coords]);

  // 2) Hook de mutación con React Query
  const { mutate: toggleLike, isLoading: isToggling } = useToggleLikeRQ(location);

  // 3) Estado local para la animación
  const [animateHeart, setAnimateHeart] = useState(false);
  const isFavorite = initialIsFavorite;

  // 4) Handler centralizado
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated) {
      // — usuario no logueado: guardamos pending y abrimos modal de signin —
      const pending = JSON.parse(localStorage.getItem('pendingLikes') || '[]');
      if (!pending.includes(petId)) {
        pending.push(petId);
        localStorage.setItem('pendingLikes', JSON.stringify(pending));
      }
      openModal(
        <ModalSignIn initialTab="login" />,
        { metadata: { modalType: 'signIn' }, overlayClassName: 'pet-detail-overlay' }
      );
      return;
    }

    // — usuario logueado: lanzamos la animación y la mutación —
    setAnimateHeart(true);
    toggleLike({ petId });
  };

  return (
    <button
      className="like-button"
      onClick={handleClick}
      disabled={isToggling}
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
      {isFavorite ? (
        <FaHeart
          className={`like-icon filled${animateHeart ? ' heart-beat' : ''}`}
          onAnimationEnd={() => setAnimateHeart(false)}
        />
      ) : (
        <FaRegHeart
          className={`like-icon outline${animateHeart ? ' heart-beat' : ''}`}
          onAnimationEnd={() => setAnimateHeart(false)}
        />
      )}
    </button>
  );
};

export default LikeButton;
